import React, { useState, FormEvent } from 'react'
import { Modal, ModalBody, ModalFooter } from '../../../components/modal'
import { useTranslation } from 'react-i18next'
import './LanguagePicker.css'
import { LanguageDefinition } from '../services'

export type Props = {
  languageDefinitions: LanguageDefinition[]
  defaultLanguageCode: string
  onSelectLanguage: (code: string) => void
  onCancel: () => void
}

function LanguagePicker(props: Props) {
  const { languageDefinitions, onSelectLanguage, onCancel, defaultLanguageCode } = props
  const [selectedLanguageCode, setSelectedLanguageCode] = useState(defaultLanguageCode)
  const { t } = useTranslation(['navigation','global'])

  function onChange(e: FormEvent<HTMLSelectElement>) {
    setSelectedLanguageCode(e.currentTarget.value)
  }

  return (
    <Modal title={t('pick_a_language')}>
      <ModalBody>
        <select id="language" value={selectedLanguageCode} onChange={onChange}>
          {languageDefinitions.map((definition: LanguageDefinition) => (
            <option key={definition.code} value={definition.code}>{definition.description}</option>
          ))}
        </select>
      </ModalBody>
      <ModalFooter>
        <button id="language-picker-cancel" onClick={onCancel}>{t('global:cancel')}</button>
        <button id="language-picker-select" onClick={() => onSelectLanguage(selectedLanguageCode)}>{t('global:select')}</button>
      </ModalFooter>
    </Modal>
  )
}

export default LanguagePicker
